import React, { useContext, useRef } from 'react';
import styled, { useTheme } from 'styled-components';
import dayjs from 'dayjs';
import { t } from 'ttag';
import { Timelapse } from '@area-monitoring/react-components';

import { ShAuthContext } from '../../../contexts/shAuthContext';
import useAreaMonitoringDimensions from '../../../hooks/useAreaMonitoringDimensions';

const TimelapseWrap = styled.div`
  height: 100%;
  width: 100%;
`;

export default function TimelapseComponent({ performanceIndex, date, field, scope, language }) {
  const timelapseRef = useRef();
  const { height: timelapseHeight, width: timelapseWidth } = useAreaMonitoringDimensions(timelapseRef);
  const { shAuthToken } = useContext(ShAuthContext);
  const theme = useTheme();

  return (
    <TimelapseWrap ref={(el) => (timelapseRef.current = el)}>
      {timelapseRef.current && (
        <Timelapse
          baseUrl={process.env.REACT_APP_SENTINEL2_WMS_ENDPOINT}
          layers={[{ layerId: performanceIndex }]}
          shAuthToken={shAuthToken}
          amServicesAuthToken={'test-token'}
          signalServiceUrl={'https://am-pilot.sinergise.com/signal/'}
          useValidSignal={true}
          language={language}
          scope={scope}
          foiId={field.id}
          defaultTimespan={{
            from: dayjs(date).startOf('year').format('YYYY-MM-DD'),
            to: dayjs(date).endOf('year').format('YYYY-MM-DD'),
          }}
          geometries={[
            {
              geometry: field.geometry,
              style: {
                strokeColor: theme.fieldColor,
                lineWidth: theme.fieldWidth,
              },
              id: 'geometry1',
              label: t`Selected field`,
            },
          ]}
          width={timelapseWidth}
          height={timelapseHeight}
          paddingXPercent={300}
          paddingYPercent={300}
          onDateSelect={() => {}}
        />
      )}
    </TimelapseWrap>
  );
}
